import { DeviceSize } from 'src/types';

interface Bounds {
  minWidth: number;
  maxWidth: number;
}

export const boundsByDeviceSize: Record<DeviceSize, Bounds> = {
  [DeviceSize.XXS]: { minWidth: 0, maxWidth: 360 },
  [DeviceSize.XS]: { minWidth: 361, maxWidth: 600 },
  [DeviceSize.S]: { minWidth: 601, maxWidth: 960 },
  [DeviceSize.M]: { minWidth: 961, maxWidth: 1200 },
  [DeviceSize.L]: { minWidth: 1201, maxWidth: 1440 },
  [DeviceSize.XL]: { minWidth: 1441, maxWidth: Infinity },
};

export const calculateDeviceSize = (width: number): DeviceSize => {
  for (const [size, { minWidth, maxWidth }] of Object.entries(
    boundsByDeviceSize,
  )) {
    if (width >= minWidth && width <= maxWidth) return size as DeviceSize;
  }

  return DeviceSize.L;
};

export const mobileDeviceSizes = new Set([DeviceSize.XXS, DeviceSize.XS]);
